export const REPORT_FILTERS_PANEL_WIDTH = 360;
